import { createListenerMiddleware } from "@reduxjs/toolkit"

import { saveSection } from "./configure.slice"
import { commitSection } from "./configure.thunks"

// Debounced auto-save, the replacement for the saga's
// `debounce(800, SAVE_SECTION_REQUEST, autoCommit)`.
//
// 800ms after the merchant stops editing a section we PATCH it to the backend so a
// refresh never loses in-progress work. The explicit Save for later / Next /
// section-switch commits still fire too; this is the safety net for "typed, walked
// away, refreshed". `cancelActiveListeners()` keeps only the latest edit in the window,
// so we commit the section the merchant is actually editing.
export const disputesConfigureListener = createListenerMiddleware()

disputesConfigureListener.startListening({
  actionCreator: saveSection,
  effect: async (action, listenerApi) => {
    const section = action.payload?.section
    if (!section) return

    listenerApi.cancelActiveListeners()
    // Throws (and so ends this run) if a newer saveSection cancels us mid-wait.
    await listenerApi.delay(800)

    listenerApi.dispatch(commitSection({ section }))
  }
})
